import Box from "@mui/material/Box";
import CircularProgress from '@mui/material/CircularProgress';

const Loader = () => {
    return (
        <Box sx={{ p: 3, pt: 4, textAlign: "center", alignItems: "center", display: 'flex', justifyContent: 'center', height: 280 }}>
            <CircularProgress />
        </Box>
    );
};

export default Loader;